var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMutation } from '@apollo/client';
import { Button, Checkbox, DialogActions, FormControlLabel, TextField, Typography } from '@mui/material';
import { SnackbarSeverity } from 'common/enums/components/snackbar-severity.enum';
import { CREATE_COMMUNITY_USER } from 'common/graphql/mutations/community/create-community-user';
import { CREATE_COMMUNITY_USER_JOIN_REQUEST } from 'common/graphql/mutations/community/create-community-user-join-request';
import { DELETE_COMMUNITY_USER_JOIN_REQUEST } from 'common/graphql/mutations/community/delete-community-user-join-request';
import { COMMUNITY_HEADER_DATA } from 'common/graphql/queries/community/community-header-data';
import { COMMUNITY_PUBLIC_FIELDS } from 'common/graphql/queries/community/community-public-fields';
import { COMMUNITY_USER_JOIN_REQUEST } from 'common/graphql/queries/community/community-user-join-request';
import useDynamicMutation from 'common/hooks/useDynamicMutation';
import CircularProgressMui from 'components/Loading/CircularProgresMui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { openSnackbar } from 'store/actions';
var JoinCommunityRequestDialog = function (_a) {
    var userId = _a.userId, joinVia = _a.joinVia, canJoinViaRequest = _a.canJoinViaRequest, joinLinkString = _a.joinLinkString, communityId = _a.communityId, communityName = _a.communityName, handleClose = _a.handleClose, communityUserJoinRequest = _a.communityUserJoinRequest;
    var dispatch = useDispatch();
    var t = useTranslation().t;
    var _b = useState(''), joinCode = _b[0], setJoinCode = _b[1];
    var _c = useState(joinVia === 'privateCode' ? 'privateCode' : canJoinViaRequest ? 'request' : 'public'), joiningType = _c[0], setJoiningType = _c[1];
    var _d = useState(''), requestMessage = _d[0], setRequestMessage = _d[1];
    var _e = useState(false), isShowMyTelegramContact = _e[0], setIsShowMyTelegramContact = _e[1];
    var onSuccess = function (message) {
        dispatch(openSnackbar({
            message: message,
            severity: SnackbarSeverity.SUCCESS
        }));
        handleClose();
    };
    var onError = function (_a) {
        var code = _a.code, errorDetails = _a.errorDetails;
        dispatch(openSnackbar({
            message: t(code) || errorDetails,
            severity: SnackbarSeverity.ERROR
        }));
    };
    var createCommunityUser = function (data) {
        return useMutation(CREATE_COMMUNITY_USER, {
            variables: {
                createCommunityUserData: {
                    communityId: communityId,
                    joinCode: (data === null || data === void 0 ? void 0 : data.joinCode) === '' ? undefined : data === null || data === void 0 ? void 0 : data.joinCode,
                    joinLinkString: joinLinkString
                }
            },
            refetchQueries: [
                {
                    query: COMMUNITY_HEADER_DATA,
                    variables: {
                        communityId: communityId
                    }
                },
                COMMUNITY_PUBLIC_FIELDS,
            ]
        });
    };
    var createJoinCommunityRequest = function (data) {
        return useMutation(CREATE_COMMUNITY_USER_JOIN_REQUEST, {
            variables: {
                createCommunityUserJoinRequestData: __assign({ communityId: communityId }, data)
            },
            refetchQueries: [
                {
                    query: COMMUNITY_USER_JOIN_REQUEST,
                    variables: {
                        communityId: communityId,
                        userId: userId
                    }
                },
            ]
        });
    };
    var deleteJoinCommunityRequest = function (data) {
        return useMutation(DELETE_COMMUNITY_USER_JOIN_REQUEST, {
            variables: {
                communityId: communityId
            },
            refetchQueries: [
                {
                    query: COMMUNITY_USER_JOIN_REQUEST,
                    variables: {
                        communityId: communityId,
                        userId: userId
                    }
                },
            ]
        });
    };
    var _f = useDynamicMutation(createCommunityUser, function () {
        onSuccess("".concat(t('Вы стали участником сообщества'), " ").concat(communityName, "."));
    }, onError), handleCreateCommunityUser = _f.handleExecuteMutation, handleCreateCommunityUserLoading = _f.loading;
    var _g = useDynamicMutation(createJoinCommunityRequest, function () {
        onSuccess(t('Заявка отправлена'));
    }, onError), handleCreateJoinCommunityRequest = _g.handleExecuteMutation, handleCreateJoinCommunityRequestLoading = _g.loading;
    var _h = useDynamicMutation(deleteJoinCommunityRequest, function () {
        onSuccess(t('Заявка отозвана'));
    }, onError), handleDeleteJoinCommunityRequest = _h.handleExecuteMutation, handleDeleteJoinCommunityRequestLoading = _h.loading;
    var handleJoin = function () {
        handleCreateCommunityUser({ joinCode: joinCode });
    };
    var handleRequest = function (data) {
        handleCreateJoinCommunityRequest(data);
    };
    var handleDeleteRequest = function () {
        handleDeleteJoinCommunityRequest({});
    };
    return (_jsxs("div", __assign({ className: "flex flex-col p-0 pb-20 max-w-320" }, { children: [_jsx("div", __assign({ className: "tw-dialog-header" }, { children: t('Вступить в сообщество') }), void 0), _jsxs(_Fragment, { children: [joinVia === 'privateCode' && joiningType === 'privateCode' && (_jsxs("div", __assign({ className: "flex flex-col items-center space-y-20 pb-20" }, { children: [_jsx(Typography, __assign({ className: "text-16 text-center dark:text-white" }, { children: _jsxs("span", { children: [_jsx("span", { children: t('Введите приватный код для входа в сообщество') }, void 0), _jsxs("span", { children: [' ', _jsx("b", { children: communityName }, void 0)] }, void 0)] }, void 0) }), void 0), _jsx(TextField, { label: t('Код для входа в сообщество'), name: "joinCode", value: joinCode || '', onChange: function (e) {
                                    setJoinCode(e.target.value);
                                }, className: "w-240" }, void 0), canJoinViaRequest && (_jsxs("div", __assign({ className: "flex flex-col items-center space-y-20 pt-20" }, { children: [_jsx("p", __assign({ className: "text-gray" }, { children: t('или') }), void 0), _jsx(Button, __assign({ variant: "text", onClick: function () {
                                            setJoiningType('request');
                                        } }, { children: t('Подать заявку') }), void 0)] }), void 0))] }), void 0)), canJoinViaRequest && joiningType === 'request' && (_jsxs("div", __assign({ className: "flex flex-col items-center space-y-20 pb-20" }, { children: [communityUserJoinRequest !== null && (_jsxs(_Fragment, { children: [_jsx("p", __assign({ className: "text-grey" }, { children: t('createCommunityJoinRequestText3') }), void 0), communityUserJoinRequest.message && (_jsx(TextField, { value: communityUserJoinRequest.message, className: "w-240", multiline: true, disabled: true }, void 0)), _jsx(FormControlLabel, { className: "dark:text-white", control: _jsx(Checkbox, { checked: communityUserJoinRequest.isShowMyTelegramContact, disabled: true }, void 0), label: t('Предоставить доступ к профилю Telegram') }, void 0)] }, void 0)), communityUserJoinRequest === null && (_jsxs(_Fragment, { children: [_jsx("p", __assign({ className: "text-grey" }, { children: t('createCommunityJoinRequestText1') }), void 0), _jsx(TextField, { label: t('Введите сообщение'), name: "requestMessage", value: requestMessage || '', onChange: function (e) {
                                            setRequestMessage(e.target.value);
                                        }, className: "w-240", multiline: true, helperText: requestMessage.length > 2040 && t('Превышена допустимая длина сообщения'), error: requestMessage.length > 2040 }, void 0), _jsx("p", __assign({ className: "text-grey" }, { children: t('createCommunityJoinRequestText2') }), void 0), _jsx(FormControlLabel, { className: "dark:text-white", control: _jsx(Checkbox, { checked: isShowMyTelegramContact, onChange: function (e) {
                                                setIsShowMyTelegramContact(e.target.checked);
                                            } }, void 0), label: t('Предоставить доступ к профилю Telegram') }, void 0)] }, void 0)), joinVia === 'privateCode' && (_jsxs("div", __assign({ className: "flex flex-col items-center space-y-20 pt-20" }, { children: [_jsx("p", __assign({ className: "text-gray" }, { children: t('или') }), void 0), _jsx(Button, __assign({ variant: "text", onClick: function () {
                                            setJoiningType('privateCode');
                                        } }, { children: t('Вступить с секретным кодом') }), void 0)] }), void 0))] }), void 0)), joinVia === 'public' && joiningType === 'public' && (_jsx(Typography, __assign({ className: "text-16 text-center pb-20 dark:text-white" }, { children: _jsxs("span", { children: [_jsx("span", { children: t('Вы уверены, что хотите стать участником сообщества') }, void 0), _jsxs("span", { children: [' ', _jsx("b", { children: communityName }, void 0)] }, void 0), "?"] }, void 0) }), void 0)), _jsxs(DialogActions, __assign({ className: "flex justify-between p-0" }, { children: [_jsx(Button, __assign({ variant: "text", type: "reset", onClick: handleClose }, { children: t('Отмена') }), void 0), _jsx(Button, __assign({ onClick: function () {
                                    if (joiningType === 'request') {
                                        if (communityUserJoinRequest !== null) {
                                            handleDeleteRequest();
                                        }
                                        else {
                                            handleRequest({
                                                message: requestMessage,
                                                isShowMyTelegramContact: isShowMyTelegramContact
                                            });
                                        }
                                    }
                                    else {
                                        handleJoin();
                                    }
                                }, type: "submit", endIcon: (handleCreateCommunityUserLoading ||
                                    handleCreateJoinCommunityRequestLoading ||
                                    handleDeleteJoinCommunityRequestLoading) && (_jsx(CircularProgressMui, { size: 20, className: "text-black" }, void 0)) }, { children: joiningType === 'request'
                                    ? communityUserJoinRequest !== null
                                        ? t('Отозвать')
                                        : t('Подать заявку')
                                    : t('Вступить') }), void 0)] }), void 0)] }, void 0)] }), void 0));
};
export default JoinCommunityRequestDialog;
